import { AppConfig } from "@/constants";
import axios from "axios";
export const errorMessage = { text: "" }; // Global error message object

// Create Axios instance
const api = axios.create({
    baseURL: AppConfig.API_BASE_URL,
});

// Attach Token & Handle Content-Type Dynamically
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");

    // Only add Authorization header for specific endpoints
    if (token && config.requiresAuth) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Dynamically set Content-Type if not already set
    if (!config.headers["Content-Type"]) {
        if (config.isMultipart) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
    }

    return config;
});

// Global Error Handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status, data } = error.response;
            errorMessage.text = `${status} - ${data.message || "An error occurred"}`;

            // Auto logout if unauthorized (401)
            if (status === 401) {
                localStorage.removeItem("access_token");
                window.location.href = "/login";
            }
        } else {
            errorMessage.text = "Network error. Please try again.";
        }
        return Promise.reject(error);
    }
);

export default api;
